import { Pipe, PipeTransform } from '@angular/core';
import { REGISTRATION_TYPE_LOOKUP, RegistrationType } from 'ag-common-lib/public-api';

@Pipe({ name: 'registrationType' })
export class RegistrationTypePipe implements PipeTransform {
  transform(registrationType: RegistrationType): string {
    return REGISTRATION_TYPE_LOOKUP.find(lookup => lookup?.value === registrationType)?.description;
  }
}
